<template>
  <b-modal
    centered
    scrollable
    hide-footer
    size="xl"
    v-if="show"
    v-model="show"
    :title="data.appName"
    title-tag="h4"
  >
    <b-card no-body>
      <b-tabs pills card vertical @input="checkTab">
        <b-tab title="全局统计" active @click="changeToWhole">
          <Whole ref="wholeTab" :appId="data.appId" @export="exportData($event)" :oversea="oversea" />
        </b-tab>
        <b-tab title="投票项统计">
          <ItemDetail v-if="itemDetailShow" ref="itemDetailTab" :appId="data.appId" :voteId="voteId" @hide="showList" @export="exportData($event)" :oversea="oversea" />
          <Item v-else ref="itemTab" :appId="data.appId" @hide="showDetail($event)" @export="exportData($event)" :oversea="oversea" />
        </b-tab>
        <b-tab title="用户投票统计">
          <User ref="userTab" :appId="data.appId" @export="exportData($event)" :oversea="oversea" />
        </b-tab>
        <b-tab title="每日统计">
          <Daily ref="dailyTab" :appId="data.appId" :oversea="oversea" :startTime="data.startTime" :endTime="data.endTime" />
        </b-tab>
        <b-tab title="每日TOP">
          <ItemTop ref="itemTopTab" :appId="data.appId" :oversea="oversea" :startTime="data.startTime" :endTime="data.endTime" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-modal>
</template>

<script>
import api from '@/utils/api'
import consts from '@/utils/consts'
import Error from '@/mixin/error'
import Whole from '@/components/VoteStatistics/Whole'
import Item from '@/components/VoteStatistics/Item'
import User from '@/components/VoteStatistics/User'
import ItemDetail from '@/components/VoteStatistics/ItemDetail'
import ItemTop from '@/components/VoteStatistics/ItemTop'
import Daily from '@/components/VoteStatistics/Daily'
import utils from '../../utils/utils'

export default {
  name: 'vote-statistics',
  mixins: [Error],
  props: ['showData', 'oversea'],
  components: {Whole, Item, User, ItemDetail, ItemTop, Daily},
  data () {
    return {
      data: { appName: '', appId: '', startTime: '', endTime: '' },
      show: false,
      itemDetailShow: false,
      voteId: null
    }
  },
  methods: {
    modalShow () {
      this.show = true
    },
    checkTab (tabIndex) {
      if (tabIndex === 1) {
        this.itemDetailShow = false
      }
    },
    changeToWhole (evt) {
      this.$refs.wholeTab.selectedDate = ''
    },
    exportData (data) {
      let tabName = data.tab
      delete data.tab
      data.app_id = this.data.appId
      data.type = this.oversea ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3)
      this.$ajax.get(api.getBaseUrl() + 'vote_project/vote_export' + utils.urlEncode(data), {responseType: 'blob'}).then((res) => {}, (res) => {
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = this.data.appName + tabName + '.csv'
        link.click()
      })
    },
    showDetail (data) {
      this.voteId = data.voteId
      this.itemDetailShow = true
    },
    showList () {
      this.itemDetailShow = false
    }
  },
  watch: {
    showData (val) {
      this.data = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VoteStatistics.vue?7da71576